import { EditInspectionOutDto, EditInspectionInDto } from '../../../types/inspection.dto'

export const EDIT_INSPECTION = 'EDIT_INSPECTION'
export const EDIT_INSPECTION_SUCCESS = 'EDIT_INSPECTION_SUCCESS'
export const EDIT_INSPECTION_ERROR = 'EDIT_INSPECTION_ERROR'
export const RESET_EDIT_INSPECTION = 'RESET_EDIT_INSPECTION'

export interface EditInspection {
  type: typeof EDIT_INSPECTION
  payload: EditInspectionOutDto
}

export interface EditInspectionSuccess {
  type: typeof EDIT_INSPECTION_SUCCESS
  payload: EditInspectionInDto
}

export interface EditInspectionError {
  type: typeof EDIT_INSPECTION_ERROR
  payload: string | boolean
}

export interface ResetEditInspection {
  type: typeof RESET_EDIT_INSPECTION
  payload: null
}
export interface State {
  data: EditInspectionInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = EditInspection | EditInspectionSuccess | EditInspectionError | ResetEditInspection
